import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import Button from 'components/util/Button'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import styles from './_ownEveryMileLanding.css'
import Svg from 'components/util/Svg'
import messages from './messages'

function OwnEveryMile (props) {
  const {
    signUp,
    logIn,
    site,
  } = props

  const {
    appStoreLink,
    shortName,
    slug,
  } = site
  const caption = messages.caption[slug] || messages.caption.default
  const title = messages.title[slug] || messages.title.default

  const inlineStyles = {
    color: 'white',
    align: 'right',
  }

  const flavorClass = styles[slug] || ''

  return (
    <div className={styles.ownEveryMileWrapper}>
      <div className={`${styles.ownEveryMile} ${flavorClass}`}>
        <Title {...inlineStyles} >
          { title ? <FormattedMessage {...title} /> : null }
        </Title>
        <Caption {...inlineStyles}>
          { caption ? <FormattedMessage {...caption} /> : null }
        </Caption>
        <div className={styles.callToAction}>
          <Button size="xlarge" type="accent" onClick={signUp}>
            <FormattedMessage id='site.nav.signup' defaultMessage='Sign Up' />
          </Button>
          <div className={styles.logIn}>
            <p className={styles.logInQuestion}>
              <FormattedMessage id='landingPage.ownEveryMile.login.question' defaultMessage='Already a member?' />
            </p>
            <Button className={styles.logInButton} size="medium" type="default" onClick={logIn}>
              <FormattedMessage id='site.nav.login' defaultMessage='Log in' />
            </Button>
          </div>
          <div className={styles.appStoreContainer}>
            <a className={styles.appStoreLink} target='_blank' rel='noopener noreferrer' href={appStoreLink}>
              <Svg className={styles.appStoreIcon} name='apple-app-store' />
            </a>
            <a className={styles.appStoreLink} target='_blank' rel='noopener noreferrer' href={`https://play.google.com/store/apps/details?id=com.${shortName}.android2&hl=en`}>
              <Svg className={styles.appStoreIcon} name='google-play-store' />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

OwnEveryMile.propTypes = {
  site: PropTypes.object,
  logIn: PropTypes.func,
  signUp: PropTypes.func,
}

export default OwnEveryMile



// WEBPACK FOOTER //
// ./src/components/landing/own-every-mile/index.jsx